module.exports = __webpack_public_path__ + "img/AD_INFOSTOCK@3x.0d36f34.png";